import { memo } from 'react';
import { Loader, Table } from 'rsuite';
import { SearchInput } from '../../../../../../components';
import { PricerAssignment, PricerAssignmentsPage } from '../types';
import { AssignmentRow } from './AssignmentRow';
import styles from '../SetupIpaPricingResponsibilities.module.scss';

const Pagination = memo(Table.Pagination);

type AssignmentListProps = {
  assignments: PricerAssignment[];
  page?: PricerAssignmentsPage;
  search: string;
  loading: boolean;
  onSearch: (value: string) => void;
  onChangePage: (page: number) => void;
  onEdit: (assignment: PricerAssignment) => void;
  onRemove: (assignment: PricerAssignment) => void;
};

export const AssignmentList = ({ assignments, page, search, loading, onSearch, onChangePage, onEdit, onRemove }: AssignmentListProps) => (
  <>
    <SearchInput
      aria-label="Buscar por responsável pela precificação ou categoria"
      className={styles['assignment-search']}
      placeholder="Buscar por responsável pela precificação ou categoria"
      value={search}
      onChange={event => onSearch(event.target.value)}
    />

    <div className={styles['assignment-list']} aria-live="polite">
      {loading ? (
        <div className={styles['list-feedback']}>
          <Loader content="Carregando atribuições..." />
        </div>
      ) : assignments.length > 0 ? (
        assignments.map(assignment => <AssignmentRow key={assignment.id} assignment={assignment} onEdit={onEdit} onRemove={onRemove} />)
      ) : search ? (
        <div className={styles['list-feedback']}>
          <p>Nenhum responsável pela precificação ou categoria encontrado para “{search}”.</p>
          <button type="button" onClick={() => onSearch('')}>
            Limpar busca
          </button>
        </div>
      ) : (
        <div className={styles['list-feedback']}>
          <p>Nenhuma atribuição configurada.</p>
        </div>
      )}
    </div>

    {(page?.totalPages ?? 0) > 1 && (
      <Pagination
        className={styles.pagination}
        total={page?.totalElements}
        displayLength={page?.size}
        activePage={(page?.number ?? 0) + 1}
        showLengthMenu={false}
        onChangePage={nextPage => onChangePage(nextPage - 1)}
      />
    )}
  </>
);
